import React from 'react';

function ContractCheckbox({ data, selected = [], onSelectChange = () => {} }) {
  if (data?.pinvInvoice?.length > 0 || data?.paid !== true) {
    return null;
  }

  return (
    <input
      type="checkbox"
      checked={selected.includes(data._id)}
      onChange={(e) => {
        e.stopPropagation();
        onSelectChange(data);
      }}
    />
  );
}

export default ContractCheckbox;
